import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ProgressBar } from "react-loader-spinner";
import Cookies from "js-cookie";

import UniversalInputComponent from "../../../../components/AdministrativeProcedures/commonComponents/universalInputComponent/UniversalInputComponent";
import AppFooterRHF from "../../../../components/AdministrativeProcedures/commonComponents/appFooterRHF/AppFooterRHF";
import ButtonsBlock from "../../../../components/GeneralComponents/buttonsBlock/ButtonsBlock";
import ResultModalWindow from "../../../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";
import QRModalWindow from "../../../../components/AdministrativeProcedures/commonComponents/QRModalWindow/QRModalWindow";
import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";
import ModalWindowWithInputs from "../../../../components/GeneralComponents/modalWindowWithInputs/modalWindowWithInputs";
import LoaderWithOverlay from "../../../../components/GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import {
  applicantInfo,
  contractInfo,
  isNeedToPaySelector,
  medicalCertificate,
  optionsForPasswordModal,
  setBirthPlaceOptions,
  setBirthPlaceOptionsByData,
  setMidnameRequiredByDocType,
  setOptionsByMode,
  setOptionsDocType,
  setOptionsTrainingProgram,
  trainingInformation,
} from "./optionsCardApplicationTrainingRHF";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

import {
  API_ADD_APPLICATION_TRAINING,
  API_EDIT_APPLICATION_TRAINING,
  API_FOR_AVEST_SIGN,
  API_GET_APPLICATION_TRAINING,
  API_GET_BILL,
  API_GET_INFO_BY_PERS_NUM,
  API_GET_INFO_BY_PERS_NUM_WITH_SIGN,
  API_GET_QR,
  API_PRINT_APPLICATION_TRAINING,
  MAIN_URL,
  PORT_FOR_INTEGRATION,
  PORT_FOR_TRAINING,
} from "../../../../constants/constants";

import styles from "./cardApplicationTrainingRHF.module.css";

export default function CardApplicationTrainingRHF() {
  const {
    register,
    unregister,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });

  const {
    register: registerModal,
    handleSubmit: handleSubmitModal,
    control: controlModal,
    formState: { errors: errorsModal },
    setValue: setValueModal,
    getValues: getValuesModal,
  } = useForm({ mode: "onChange" });

  const mode = (() => {
    switch (true) {
      case window.location.pathname.includes("add"):
        return "add";
      case window.location.pathname.includes("view"):
        return "view";
      case window.location.pathname.includes("edit"):
        return "edit";
      default:
        break;
    }
  })();
  const idStatement =
    window.location.pathname.includes("view") || window.location.pathname.includes("edit")
      ? window.location.pathname.split("/").at(-1)
      : "";
  const downloadAPI = "https://gims-dev.compit.by:8083/training/download/attachment/";
  const validationKeys = [
    "docDateIssue",
    "appDate",
    "birthDate",
    "documentMedicalDocDate",
    "dateStart",
    "contractDate",
  ];
  const navigate = useNavigate();
  const userId = Cookies.get("userId");

  const [options, setOptions] = useState({
    applicantInfo: applicantInfo,
    medicalCertificate: medicalCertificate,
    trainingInformation: trainingInformation,
    contractInfo: contractInfo,
  });

  const [newData, setNewData] = useState({
    appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    isNeedToPaySelector: true,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [file, setFile] = useState("");
  const [viewFileName, setViewFileName] = useState("");

  const [showResultModal, setShowResultModal] = useState(false);
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [serviceBill, setServiceBill] = useState(null);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [isPrinted, setIsPrinted] = useState(false);

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_APP?.printApplication?.chapterActionId,
  );

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const handleCloseApp = () => {
    setFile(null);
    setNewData(
      structuredClone({
        appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
      }),
    );
    setErrorText("");
    setHeaderText("");
    navigate("/applicationfortraining");
  };

  const setOptionsFromLibs = async () => {
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      setOptions({
        ...options,
        applicantInfo: setOptionsTrainingProgram(dictionaryReducer.trainingProgramLibrary),
      });
    }
    if (dictionaryReducer.identificationDocuments.length > 0) {
      setOptions({
        ...options,
        applicantInfo: setOptionsDocType(dictionaryReducer.identificationDocuments),
      });
    }
    if (dictionaryReducer.allCountries.length > 0) {
      setOptions({
        ...options,
        applicantInfo: setBirthPlaceOptions(dictionaryReducer.allCountries),
      });
    }
    if (
      dictionaryReducer.trainingProgramLibrary.length > 0 &&
      dictionaryReducer.identificationDocuments.length > 0 &&
      dictionaryReducer.allCountries.length > 0
    ) {
      setIsLoading(false);
    }
  };

  const getUserInfoById = async () => {
    const { persNum } = getValues();
    const { pw } = getValuesModal();

    clearErrors("persNum");
    setIsLoadingModal(true);
    await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_PERS_NUM + persNum, {
      headers: { "Content-Type": "application/json" },
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Ошибка сети: ${res.status}`);
        }
        return res.json();
      })
      .then(async (dataForInnerRequest) => {
        let resInner;
        let resWithData;

        try {
          resInner = await fetch(API_FOR_AVEST_SIGN, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...dataForInnerRequest, pw: pw }),
          });
        } catch (error) {
          resWithData = await fetchWithToken(
            MAIN_URL +
              PORT_FOR_INTEGRATION +
              API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
              `${userId}/${persNum}?agent=1`,
            {
              method: "POST",
              body: JSON.stringify({
                headers: null,
                body: null,
                identificationNumber: persNum,
                log: false,
              }),
              headers: { "Content-Type": "application/json" },
            },
          );
        }
        if (resInner) {
          if (!resInner.ok) {
            const errorText = await resInner.text();
            if (errorText === "Invalid container password") {
              throw new Error(`Ошибка подписи! Неверный пароль.`);
            }
            resWithData = await fetchWithToken(
              MAIN_URL +
                PORT_FOR_INTEGRATION +
                API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                `${userId}/${persNum}?agent=1`,
              {
                method: "POST",
                body: JSON.stringify({
                  headers: null,
                  body: null,
                  identificationNumber: persNum,
                  log: false,
                }),
                headers: { "Content-Type": "application/json" },
              },
            );
          } else {
            const dataWithSign = await resInner.json();

            resWithData = await fetchWithToken(
              MAIN_URL +
                PORT_FOR_INTEGRATION +
                API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                `${userId}/${persNum}?agent=1`,
              {
                method: "POST",
                body: JSON.stringify(dataWithSign),
                headers: { "Content-Type": "application/json" },
              },
            );
          }
        }
        const dataWithInformation = await resWithData.json();
        if (!resWithData.ok) {
          throw new Error(dataWithInformation.message);
        } else {
          setOptions({
            ...options,
            applicantInfo: setBirthPlaceOptionsByData(dataWithInformation),
          });
          if (dataWithInformation.docType) {
            setOptions({
              ...options,
              applicantInfo: setMidnameRequiredByDocType(dataWithInformation.docType),
            });
          }
          // setNewData((prevData) => ({ ...prevData, ...dataWithInformation }));
          for (const item in dataWithInformation) {
            setValue(item, dataWithInformation[item]);
          }
          setValueModal("pw", "");
          setShowPasswordModal(false);
        }
      })
      .catch((error) => {
        setOptions({
          ...options,
          applicantInfo: setBirthPlaceOptionsByData(),
        });
        setValueModal("pw", "");
        setErrorText(error.message);
        setHeaderText("Заполните поля вручную или повторите заново");
        setRegistrationResult("error");
        setShowResultModal(true);
        clearErrors("persNum");
        setIsLoadingModal(false);
      });
    clearErrors("persNum");
    setIsLoadingModal(false);
  };

  const resolveSubmit = async (data) => {
    const formData = new FormData();
    if (file) {
      formData.append(`file`, file);
    }
    formData.append("data", JSON.stringify(data));
    let response = null;
    if (mode === "add") {
      const { address, surname, name, midname, programId, phone, isNeedToPaySelector } = getValues();

      if (!isNeedToPaySelector) {
        response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_ADD_APPLICATION_TRAINING, {
          method: "POST",
          body: formData,
        });
        if (response.status !== 200) {
          let errorText = await response.json().then((data) => data.message);
          if (errorText) {
            setHeaderText("Произошла ошибка");
            setErrorText(errorText);
          }
          setRegistrationResult("error");
          setShowResultModal(!showResultModal);
        } else {
          const responseText = await response.text();
          setAppId(responseText);
          setShowResultModal(!showResultModal);
          setRegistrationResult("success");
        }
        return;
      }
      setIsLoadingModal(true);
      const createdBill = await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          address,
          surname,
          name,
          midname,
          programId,
          phone,
          paidProcType: 5,
        }),
      });

      if (!createdBill.ok) {
        const response = await createdBill.json();
        setIsLoadingModal(false);
        setErrorText("Зарегистрируйте заявление без выставления счёта на оплату или попробуйте позже.");
        setHeaderText(response.message);
        setShowResultModal(!showResultModal);
      } else {
        const responseInner = await createdBill.json();
        if (responseInner.id) {
          fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR, {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              serviceBillId: responseInner.serviceBillId,
            }),
          })
            .then((data) => data.blob())
            .then((blob) => {
              setServiceBill({
                id: responseInner.serviceBillId,
                QRurl: URL.createObjectURL(blob),
                onClose: async () => {
                  formData.set(
                    "data",
                    JSON.stringify({
                      ...JSON.parse(formData.get("data")),
                      billDataId: createdBill.id,
                    }),
                  );

                  response = await fetchWithToken(
                    MAIN_URL + PORT_FOR_TRAINING + API_ADD_APPLICATION_TRAINING,
                    {
                      method: "POST",
                      body: formData,
                    },
                  );

                  if (response.status !== 200) {
                    let errorText = await response.json().then((data) => data.message);
                    if (errorText) {
                      setHeaderText("Произошла ошибка");
                      setErrorText(errorText);
                    }
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("error");
                  } else {
                    const responseText = await response.text();
                    setAppId(responseText);
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                  }

                  setShowBillContractModal(false);
                },
              });
              setIsLoadingModal(false);
              setShowBillContractModal(true);
            });
        }
      }
    }
    if (mode === "edit") {
      response = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_EDIT_APPLICATION_TRAINING + String(idStatement),
        {
          method: "POST",
          body: formData,
        },
      );
    }

    if (response) {
      if (response.status !== 200) {
        let errorText = await response.json().then((data) => data.message);
        if (errorText) {
          setHeaderText("Произошла ошибка");
          setErrorText(errorText);
        }
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      } else {
        const responseText = await response.text();
        // setAppId(responseText);
        setShowResultModal(!showResultModal);
        setRegistrationResult("success");
      }
    }
  };

  const handleDownloadFile = async (data) => {
    const request = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_PRINT_APPLICATION_TRAINING, {
      method: "POST",
      body: JSON.stringify(data),
    });
    if (request.status !== 200) {
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");
    } else {
      setIsLoadingModal(true);
      const formData = await request.formData();
      const fileDocx = formData.get("docx");
      const fileUrl = URL.createObjectURL(fileDocx);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileDocx.name;
      link.click();
      setIsPrinted(true);
      setIsLoadingModal(false);
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (type !== undefined) {
        if (newData[name] !== value[name] && value[name] !== undefined) {
          newData[name] = value[name];
          // newData[name] = typeof value[name] === "string" ? value[name].toUpperCase() : value[name];
          // const newValue = typeof value[name] === "string" ? value[name].toUpperCase() : value[name];
          // setNewData((prevData) => ({ ...prevData, [name]: newValue }));
        }
        // if (name === "dateStart" || name === "dateEnd") handleDateStartEndValidation(value[name], name);
        if (name === "docType")
          setOptions({
            ...options,
            applicantInfo: setMidnameRequiredByDocType(value[name]),
          });
        // if (validationKeys.includes(name)) handleCustomValidation(value[name], name);
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_GET_APPLICATION_TRAINING + String(idStatement),
      );
      if (response.status !== 200) {
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      } else {
        const dataStatement = await response.json();
        dataStatement.viewFileName = dataStatement?.fotoName;
        dataStatement.appFileId = dataStatement?.fotoId;
        dataStatement.inspector = dataStatement?.appUser;
        if (mode === "view") {
          for (let item in dataStatement) {
            if (validationKeys.includes(item)) {
              dataStatement[item] = dataStatement[item]?.split("-").reverse().join(".");
            }
          }
          setNewData(dataStatement);
        } else {
          for (let item in dataStatement) {
            setValue(item, dataStatement[item]);
          }
          setNewData({ ...newData, ...dataStatement });
        }

        setIsLoading(false);
      }
    }
    switch (mode) {
      case "add":
        setNewData({
          appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
        });
        setIsLoading(false);
        break;
      default:
        fetchData();
        break;
    }
    setOptions(setOptionsByMode(mode));
  }, []);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
    setValue("isNeedToPaySelector", true);
  }, []);

  useEffect(() => {
    if (getValues("isNeedToPaySelector") === undefined) {
      setValue("isNeedToPaySelector", true);
    }
  }, [getValues("isNeedToPaySelector")]);

  return (
    <div className={styles["content-container"]}>
      <h1 className={styles["main-text"]}>Заявление</h1>

      <p className={styles["description-text"]}>о зачислении на обучение правилам управления судами</p>
      {isLoading ? (
        <div className={`d-flex flex-column align-items-center `}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      ) : (
        <form onSubmit={handleSubmit(resolveSubmit)}>
          <UniversalInputComponent
            options={options.applicantInfo}
            mode={mode === "add" ? "add" : "view"}
            styles={styles}
            register={register}
            unregister={unregister}
            newData={newData}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
            handleCustomButton={() => {
              if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("persNum"))) {
                setError("persNum", {
                  type: "manual",
                  message: `Для поиска введите номер в формате "0000000A000AA0"`,
                });
              } else {
                clearErrors("persNum");
                setShowPasswordModal(true);
              }
            }}
          />
          <UniversalInputComponent
            options={options.medicalCertificate}
            mode={mode}
            styles={styles}
            register={register}
            newData={newData}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
          />
          <UniversalInputComponent
            options={options.trainingInformation}
            mode={mode}
            styles={styles}
            register={register}
            newData={newData}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
            getValues={getValues}
          />
          <UniversalInputComponent
            options={options.contractInfo}
            mode={mode}
            styles={styles}
            register={register}
            newData={newData}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
          />
          {mode === "add" && (
            <div className={styles["need-to-pay-block"]}>
              <InputsCreatorUniversal
                option={isNeedToPaySelector}
                styles={styles}
                register={register}
                newData={newData}
                control={control}
                setValue={setValue}
                mode={mode}
                errors={errors}
                clearErrors={clearErrors}
              />
            </div>
          )}
          <AppFooterRHF
            mode={mode}
            register={register}
            control={control}
            setValue={setValue}
            clearErrors={clearErrors}
            errors={errors}
            newData={newData}
            styles={styles}
            handleFile={handleFile}
            clearFile={clearFile}
            fileName={file?.name}
            fileDownloadApi={downloadAPI}
            viewFileName={viewFileName}
            typeOfReceivedFile={".jpg,.jpeg,.png"}
            needSheetCnt={false}
          />
          <ButtonsBlock
            closeBtnText={!isPrinted && "Закрыть"}
            saveBtnText={(mode === "add" && "Сохранить") || (mode === "edit" && "Сохранить изменения")}
            extraBtnText={mode === "add" && printAccess && "Распечатать"}
            handleCloseBtn={handleCloseApp}
            handleExtraBtn={handleSubmit(handleDownloadFile)}
          />
        </form>
      )}
      <ModalWindowWithInputs
        showModal={showPasswordModal}
        setShowModal={setShowPasswordModal}
        textButton={"Найти"}
        externalStyles={styles}
        inputsOptions={optionsForPasswordModal}
        mode={"add"}
        handleSubmit={handleSubmitModal}
        register={registerModal}
        control={controlModal}
        setValue={setValueModal}
        errors={errorsModal}
        clearErrors={clearErrors}
        handle={getUserInfoById}
        isLoadingModal={isLoadingModal}
      />
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
          errorText={errorText}
          headerTextExternal={headerText}
          handleCloseExternal={() => setShowPasswordModal(false)}
        />
      )}
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      <LoaderWithOverlay isLoading={isLoadingModal} />
    </div>
  );
}
